import { BILLING_CODE_DECIMAL_POINTS } from 'af-constants/values';

export const dollarFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

const dollarFormatterUnitPriceCache = new Map<string, Intl.NumberFormat>();

export const dollarFormatterUnitPrice = (maximumFractionDigits?: number, minimumFractionDigits?: number) => {
	const key = `${maximumFractionDigits ?? BILLING_CODE_DECIMAL_POINTS}-${minimumFractionDigits ?? 0}`;
	let formatter = dollarFormatterUnitPriceCache.get(key);
	if (!formatter) {
		formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			maximumFractionDigits: maximumFractionDigits ?? BILLING_CODE_DECIMAL_POINTS,
			minimumFractionDigits: minimumFractionDigits ?? 0,
		});
		dollarFormatterUnitPriceCache.set(key, formatter);
	}
	return formatter;
};

const numberFormatterCache = new Map<string, Intl.NumberFormat>();

export const numberFormatter = (maximumFractionDigits?: number, minimumFractionDigits?: number) => {
	const key = `${maximumFractionDigits ?? BILLING_CODE_DECIMAL_POINTS}-${minimumFractionDigits ?? 0}`;
	let formatter = numberFormatterCache.get(key);
	if (!formatter) {
		formatter = new Intl.NumberFormat('en-US', {
			maximumFractionDigits: maximumFractionDigits ?? BILLING_CODE_DECIMAL_POINTS,
			minimumFractionDigits: minimumFractionDigits ?? 0,
		});
		numberFormatterCache.set(key, formatter);
	}
	return formatter;
};

const dollarUnitFormatterCache = new Map<string, Intl.NumberFormat>();

export const dollarUnitFormatter = (maximumFractionDigits?: number, minimumFractionDigits?: number) => {
	const key = `${maximumFractionDigits ?? 2}-${minimumFractionDigits ?? 2}`;
	let formatter = dollarUnitFormatterCache.get(key);
	if (!formatter) {
		formatter = new Intl.NumberFormat('en-US', {
			maximumFractionDigits: maximumFractionDigits ?? 2,
			minimumFractionDigits: minimumFractionDigits ?? 2,
		});
		dollarUnitFormatterCache.set(key, formatter);
	}
	return formatter;
};
